<fieldset class="c-form-field">
  <!-- Question -->
  @for (text of questionDetails.QuestionText; track text) {
    <legend [attr.headerid]="text" class="c-form-field__label">{{ text | translate }}</legend>
  }

  <!-- Radio style answer choices list -->
  <ul class="c-form-field__input">
    @for (answer of questionDetails.PossibleAnswers; track answer; let i = $index) {
      <li class="c-input c-input--radio">
        <input type="radio" id="{{questionDetails.QuestionId}}-{{answer.AnswerId}}" name="{{questionDetails.QuestionId}}" [attr.answerId]="answer.AnswerId" value="{{answer.AnswerId}}" [checked]="activeIndex === i" (change)="activeIndex = i; this.answerSelected(questionDetails.QuestionId, answer, i)"> <label class="c-form-field__label" for="{{questionDetails.QuestionId}}-{{answer.AnswerId}}">{{answer.AnswerText | translate}}</label>
      </li>
    }
  </ul>
</fieldset>
